import { BehaviorSubject } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { States } from '@core/services/site-state/site-state';

const states: States = Object.freeze({
    backdrop: false,
    mobileMenu: false,
    search: false,
    dialog: false,
    progress: false
});

@Injectable({
    providedIn: 'root'
})
export class SiteStateService {
    private readonly stateBs$ = new BehaviorSubject<States>(states);
    public state$ = this.stateBs$.asObservable();

    public setState(state: keyof States, value: boolean): void {
        this.state$
            .pipe(
                map(currentState => ({ ...currentState, [state]: value })),
                take(1)
            )
            .subscribe(newState => this.stateBs$.next(newState));
    }

    /**
     * Use this to trigger multiple state updates, avoid if possible to
     * change state not related to current scope
     * @param state
     */
    public setMultipleStates(state: Partial<States>): void {
        this.state$
            .pipe(
                map(currentState => ({
                    ...currentState,
                    ...state
                })),
                take(1)
            )
            .subscribe(newState => this.stateBs$.next(newState as States));
    }

    public resetState(): void {
        this.state$
            .pipe(
                map(
                    currentState =>
                        Object.keys(currentState).reduce((curr, key) => ({ ...curr, [key]: false }), {}) as States
                ),
                take(1)
            )
            .subscribe(newState => this.stateBs$.next(newState));
    }
}
